import { CategoriesResponse } from '@shopby/shop-sdk'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import {
  EventContentType,
  EventDetailProduct,
  EventDetailType,
  HomeSectionType,
  SectionDetailType,
} from '../../@types/home'
import { getEventDetail, getSectionsDetail } from '../../api/home'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { errorBgImg, setPrevScroll } from '../../js/script'
import { BtnHomeModuleMore } from '../Button'
import { useAppContext } from '../provider/AppProvider'
import HotEventItem from './HotEventItem'

interface HotEventProps {
  el: HomeSectionType
  index: number
  setTagName: React.Dispatch<React.SetStateAction<Array<string>>>
  setCheckTag: React.Dispatch<React.SetStateAction<number>>
  eventTagItem: EventContentType[]
  category: CategoriesResponse | null
}

export default function HotEvent({ el, index, setTagName, setCheckTag, eventTagItem, category }: HotEventProps) {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const [sectionItem, setSectionItem] = useState<SectionDetailType | null>(null)
  const [item, setItem] = useState<EventContentType | null>(null)
  const [eventProduct, setEventProduct] = useState<EventDetailProduct[]>([])
  const [eventData, setEventData] = useState<EventDetailType>()

  useEffect(() => {
    const fetchAllDetails = async () => {
      try {
        // 섹션 상세 데이터 요청
        const sectionRes = await getSectionsDetail(`${el.sectionNo}`)
        const sectionResItem = sectionRes.data[0]
        setSectionItem(sectionResItem)

        // 태그 추출 및 업데이트
        const tag = sectionResItem.sectionExplain.split('-')[1]
        setTagName((prev: Array<string>) => [...prev, tag])
        setCheckTag((prev: number) => prev + 1)
        // 태그 기반 이벤트 찾기
        const event = eventTagItem?.find((item: EventContentType) => item.tag.includes(tag))
        setItem(event || null)
        // 이벤트 상세 데이터 요청
        if (event?.eventNo) {
          const eventRes = await getEventDetail(event.eventNo, 'ADMIN_SETTING')
          setEventData(eventRes.data)
          setEventProduct(eventRes.data?.section[0]?.products || [])
        }
      } catch (err) {
        console.error(err)
      }
    }

    fetchAllDetails()
  }, [el.sectionNo, eventTagItem])

  const promotionClickHandler = useCallback(() => {
    const gtmNavigateClick: DataLayerArgs = {
      dataLayer: {
        event: 'select_content',
        event_info: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      },
    }
    if (isAppView) {
      sendSetAppsflyerEvent({
        eventName: 'select_content',
        eventType: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      })
    } else {
      TagManager.dataLayer(gtmNavigateClick)
    }
  }, [isAppView, el.sectionNo, el.sectionName])

  const moreButtonClickHandler = useCallback(() => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/exhibitiondetail/${item?.eventNo}`,
      })
    } else {
      navigate(`/exhibitiondetail/${item?.eventNo}`)
    }
  }, [navigate, item, setPrevScroll])

  const promotionBannerStyle = useMemo(
    () => ({
      backgroundImage: `url(${eventData ? (isMobile ? eventData.mobileimageUrl : eventData.pcImageUrl) : errorBgImg})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: eventData ? 'cover' : '36px 36px',
    }),
    [eventData]
  )
  return (
    <div className='promotion' onClick={promotionClickHandler} style={{ minHeight: isMobile ? '740px' : '628px' }}>
      <div className='home_module_title'>
        <p>{sectionItem?.promotionText}</p>
        <p>
          <strong>{sectionItem?.sectionExplain.split('-', 1).join('')}</strong>
        </p>
      </div>
      <div className='promotion_contents'>
        <div className='promotion_banner'>
          <div
            onClick={() => {
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/exhibitiondetail/${item?.eventNo}`,
                })
              } else {
                navigate(`/exhibitiondetail/${item?.eventNo}`)
              }
            }}
          >
            <div className='promotion_dim'></div>
            <div className='promotion_text_wrap'>
              <div className='promotion_title'>{item?.label}</div>
              {item?.promotionText && <div className='promotion_desc'>{item.promotionText}</div>}
            </div>
            <div className='promotion_banner_img' style={promotionBannerStyle}>
              <img
                src={`../images/exhibition_home_bg.png`}
                alt='기획전 배너'
                style={{
                  position: isMobile ? 'relative' : 'absolute',
                  borderRadius: '10px',
                  backgroundImage: `url(${
                    eventData ? (isMobile ? eventData?.mobileimageUrl : eventData?.pcImageUrl) : errorBgImg
                  })`,
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: eventData ? 'cover' : '36px 36px',
                }}
              />
            </div>
          </div>
        </div>
        <div className='promotion_item'>
          <ul>
            {eventProduct.slice(0, 3).map((element: EventDetailProduct, idx: number) => (
              <HotEventItem
                el={element}
                key={element.productNo}
                category={category}
                listId={el.sectionNo}
                listName={el.sectionName}
                idx={idx}
                promotion_id={item?.eventNo || 0}
                promotion_name={item?.label || ''}
              />
            ))}
          </ul>
        </div>
      </div>
      {eventProduct.length !== 0 && (
        <div className='btn_more_wrap'>
          <BtnHomeModuleMore onClick={moreButtonClickHandler}>더보기</BtnHomeModuleMore>
        </div>
      )}
      {index !== 0 && <hr />}
    </div>
  )
}
